export default "__VITE_ASSET__BkaaiRvG__"